export default __webpack_public_path__ + "static/media/upload-cloud.e9743f5a.svg";